import { render, staticRenderFns } from "./SearchResultStages.vue?vue&type=template&id=5dbe0c1d&scoped=true&"
import script from "./SearchResultStages.vue?vue&type=script&lang=js&"
export * from "./SearchResultStages.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultStages.vue?vue&type=style&index=0&id=5dbe0c1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbe0c1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
